import {createAction} from '@reduxjs/toolkit'

export const shareEvent = createAction<{eventId: string; buttonName: string}>('SHARE_EVENT')
